module.exports = __webpack_public_path__ + "img/2010 winteressen 035.78488713.jpg";